import { memo, useMemo } from 'react'
import Icon from 'components/core/Icon/Icon'
import Layout from 'components/core/Layout/Layout'
import Modal from 'components/interface/Modal/Modal'

/**
 * The `ModalMarketplaceCartFull`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function ModalMarketplaceCartFull (props) {
  const title = useMemo(() => <h1>Your Cart Is Full!</h1>, [])

  return (
    <Modal.Container size="x-small">
      <Modal.Media size="small">
        <Icon icon="warn" />
      </Modal.Media>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <Layout.Body align="center">
          <p>
            You have reached the maximum number of items you can have in your
            cart! Please remove some items before continuing, or proceed to
            checkout.
          </p>
        </Layout.Body>
      </Modal.Body>
      <Modal.Footer />
    </Modal.Container>
  )
}

/** @type {object} */
ModalMarketplaceCartFull.propTypes = {}

/** @type {object} */
ModalMarketplaceCartFull.defaultProps = {}

// Memoize
export default memo(ModalMarketplaceCartFull)
